export { default } from './withNumericRatingItemStyle';
